

export const API_URL = "https://api.cms.lions306c1.org/";

//const API_URL = "https://api.cms.lions306c1.org/";

//export default API_URL;